'use client';

import { useQuery } from '@tanstack/react-query';
import parse from 'html-react-parser';
import { CreditCard } from 'lucide-react';
import { Link } from 'shared/lib/i18n';
import { Button } from 'shared/ui/button';
import { getBalance } from '@/enteties/balance/api';
import { balanceKeys } from '@/enteties/balance/api/balance.query-keys';
// eslint-disable-next-line import/no-cycle
import { BalanceSkeleton } from 'widgets/balance-display';
import { useSession } from '@/app/_providers/session-provider';
import * as m from '@paraglide/messages';
const currency = {
  RUB: '&#8381;',
  USD: '&#36;'
};
export const BalanceDisplay = ({
  menuItem = false,
  closeMenu
}: {
  menuItem?: boolean;
  closeMenu?: () => void;
}) => {
  const session = useSession();

  // const { data: sessionData } = useQuery({
  //   queryKey: ['session'],
  //   queryFn: async () => {
  //     try {
  //       const response = await fetch('/api/login/refresh', {
  //         method: 'GET',
  //         credentials: 'include',
  //       });
  //
  //       if (!response.ok) {
  //         throw new Error('Failed to refresh token');
  //       }
  //
  //       return { status: 'OK' };
  //     } catch (error) {
  //       // eslint-disable-next-line no-console
  //       console.error('Error refreshing access token:', error);
  //       return { status: 'ERROR' };
  //     }
  //   },
  //   enabled: session !== null && isAccessTokenExpired(session.expires_at),
  // });

  const {
    data
  } = useQuery({
    queryKey: balanceKeys.usersBalance,
    queryFn: () => getBalance()
  });
  if (menuItem) return <Button variant="ghost" className="w-full justify-between" onClick={closeMenu} asChild>
        <Link href="/balance" title="Balance Page">
          <div className="flex w-full items-center justify-between">
            <div className="flex">
              <CreditCard className="mr-2 size-4" />
              <span>{m.header_balance()}:</span>
            </div>

            {data?.balance ? <p className="text-body2 font-medium ">
                {data?.balance?.toFixed(2)} {parse(currency[data?.currency])}
              </p> : <BalanceSkeleton />}
          </div>
        </Link>
      </Button>;
  return <Button variant="ghost" size="sm" asChild className="duration-200 active:text-primary-active px-1 sm:px-2" data-sentry-element="Button" data-sentry-component="BalanceDisplay" data-sentry-source-file="balance-display.tsx">
      <Link href="/balance" title="Balance Page" data-sentry-element="Link" data-sentry-source-file="balance-display.tsx">
        {data?.balance ? <p className="font-medium ">
            {data?.balance?.toFixed(2)} {parse(currency[data?.currency])}
          </p> : <BalanceSkeleton />}
      </Link>
    </Button>;
};